import { ModuleWithProviders, NgModule } from '@angular/core';
import { RootStoreModule } from './root-store.module';
import { EnvConfiguration } from './env-configuration';
import {
  ALGOLIA_CONFIG_TOKEN,
  APP_ENVIRONMENT_TOKEN,
  CLIENT_WEB_APP_PROJECT
} from './helpers/get-toekns';

@NgModule({
  declarations: [],
  imports: [RootStoreModule],
  providers: [],
  exports: [RootStoreModule],
})
export class SleipNgrxStoreModule {
  static forRoot(
    configuration: EnvConfiguration
  ): ModuleWithProviders<SleipNgrxStoreModule> {
    return {
      ngModule: SleipNgrxStoreModule,
      providers: [
        { provide: ALGOLIA_CONFIG_TOKEN, useValue: configuration.algolia },
        { provide: APP_ENVIRONMENT_TOKEN, useValue: configuration.env },
        { provide: CLIENT_WEB_APP_PROJECT, useValue: configuration.clientWebAppProject },
      ],
    };
  }
}
